var map = {
	"./channel.svg": 269,
	"./currency.svg": 112,
	"./delete-blue.svg": 77,
	"./delete-white.svg": 110,
	"./exit.svg": 111,
	"./inp-error.svg": 270,
	"./inp-success.svg": 271,
	"./language.svg": 272,
	"./platform.svg": 273,
	"./shops.svg": 274,
	"./tree-minus.svg": 275,
	"./tree-plus.svg": 276,
	"./zoom.svg": 277
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 268;